import SEOHead from '@/components/feature/SEOHead';
import SchemaOrg from '@/components/feature/SchemaOrg';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedSection from './components/FeaturedSection';
import PopularSection from './components/PopularSection';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@type': 'WebSite',
    name: '非麻瓜漫画',
    url: 'https://feimanggua.com',
    description: '非麻瓜漫画✨为你汇聚魔法漫画、奇幻漫画与异能漫画，免费在线阅读完整篇章，下拉式一看到底，畅游魔法世界漫画大全。',
    inLanguage: 'zh-CN',
  };

  const organizationSchema = {
    '@type': 'Organization',
    name: '非麻瓜漫画',
    url: 'https://feimanggua.com',
    description: '非麻瓜漫画 - 魔法漫画与奇幻漫画大全 | 异能漫画免费下拉式全集',
  };

  const faqSchema = {
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '非麻瓜漫画是什么？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '非麻瓜漫画是一个专注于魔法、奇幻和异能题材的免费漫画阅读平台。我们为读者提供下拉式阅读体验，让你可以一口气畅读完整篇章。',
        },
      },
      {
        '@type': 'Question',
        name: '非麻瓜漫画是否完全免费？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '是的，非麻瓜漫画上所有漫画作品均免费向读者开放。我们致力于为漫画爱好者提供一个无障碍的阅读平台。',
        },
      },
      {
        '@type': 'Question',
        name: '支持哪些设备阅读？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '非麻瓜漫画完美适配电脑、平板和手机等各类设备。我们采用响应式设计，无论你使用什么设备访问，都能获得流畅舒适的阅读体验。',
        },
      },
    ],
  };

  return (
    <>
      <SEOHead
        title="非麻瓜漫画 - 魔法漫画与奇幻漫画大全 | 异能漫画免费下拉式全集"
        description="非麻瓜漫画✨为你汇聚魔法漫画、奇幻漫画与异能漫画，🔍免费在线阅读完整篇章，下拉式一看到底，畅游魔法世界漫画大全。非麻瓜漫画提供高清全彩漫画免费在线观看。"
        keywords="非麻瓜漫画,魔法漫画,奇幻漫画,异能漫画,魔法世界漫画,非麻瓜专属漫画,免费漫画,漫画全集,下拉式漫画,好看漫画,在线漫画,奇幻漫画大全"
        canonicalUrl="https://feimanggua.com"
        ogImage="https://readdy.ai/api/search-image?query=A%20beautiful%20collage%20of%20magical%20manga%20and%20fantasy%20comic%20art%2C%20rich%20warm%20colors%2C%20golden%20and%20crimson%20accents%2C%20magical%20atmosphere%2C%20platform%20name%20non%20muggle%20comics%20in%20Chinese&width=1200&height=630&seq=og-home&orientation=landscape"
      />
      <SchemaOrg data={[organizationSchema, websiteSchema, faqSchema]} />

      <ScrollToTop />
      <Navbar />

      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedSection />
        <PopularSection />
        <FAQSection />
      </main>

      <Footer />
    </>
  );
}